<template>
  <!-- eslint-disable max-len -->
  <div class="modal-parent">
    <div
      v-shortkey="['esc']"
      class="modal"
      @shortkey="closeModal"
    >
      <div class="modal_topbar modal_topbar--no-actions">
        <div
          id="title-device-modal"
          class="modal_topbar-title modal_topbar-title--no-actions"
        >
          Add Link Device
        </div>
        <div class="modal_topbar_action modal_topbar_action--no-actions">
          <template v-if="loading">
            <loader :size="25" />
          </template>
        </div>
        <span
          id="exit-device-modal"
          class="modal_topbar-exit"
          @click="closeModal"
          v-html="closeIcon"
        />
      </div>
      <template v-if="currentStep === 0">
        <div class="modal__description">
          Which solution would you like to configure your BioConnect Link for?
        </div>
        <div class="device-container">
          <button
            id="door-device-modal"
            class="btn btn__image"
            :class="{ 'btn__image--selected': isSelected('door') }"
            @click="selectDeviceType(deviceOptions.door)"
          >
            <img
              class="btn__image-img"
              :src="doorIcon"
            />
            <div class="device__solution">
              Door Access
            </div>
          </button>
          <button
            id="cabinet-device-modal"
            class="btn btn__image"
            :class="{ 'btn__image--selected': isSelected('cabinet') }"
            @click="selectDeviceType(deviceOptions.cabinet)"
          >
            <img
              class="btn__image-img"
              :src="cabinetIcon"
            />
            <div class="device__solution">
              Server Cabinet
            </div>
          </button>
          <button
            id="safe-device-modal"
            class="btn btn__image"
            :class="{ 'btn__image--selected': isSelected('safe') }"
            @click="selectDeviceType(deviceOptions.safe)"
          >
            <img
              class="btn__image-img"
              :src="safeIcon"
            />
            <div class="device__solution">
              Safe or Key Cabinet
            </div>
          </button>
        </div>
        <div class="modal_footer modal_footer--right">
          <div
            id="error-device-modal"
            class="error"
          >
            {{ errorMessage }}
          </div>
          <button
            id="continue-device-modal"
            class="btn"
            @click="toStep(1)"
          >
            continue
          </button>
        </div>
      </template>
      <template v-if="currentStep === 1">
        <div
          v-if="deviceType === deviceOptions.safe.type"
          class="modal__description"
        >
          Please enter the MAC Address that can be found under the QR code sticker on the safe, or
          on the screen.
        </div>
        <div
          v-else
          class="modal__description"
        >
          Please enter the MAC Address found on your BioConnect Link device.
        </div>
        <div class="flex-grid">
          <template class="device-image flex-grid">
            <safe-image
              v-if="deviceType === deviceOptions.safe.type"
              :mac-address="macAddress ? macAddress : 'a1:b2:c3:d4:e5:f6'"
              class="column--two"
            />
            <link-device-image
              v-else
              :mac-address="deviceColours.macAddress"
              class="column--two"
            />
          </template>
          <div class="form-container column--two">
            <label class="form-label">MAC Address</label>
            <input
              id="address-input-device-modal"
              v-model="macAddress"
              v-focus
              class="form-field"
              type="text"
              maxlength="17"
              placeholder="eg. a1:b2:c3:d4:e5:f6"
              @keydown="macHelper($event)"
              @keyup="macHelper($event)"
            />
          </div>
        </div>
        <div class="modal_footer">
          <button
            id="back-device-modal"
            class="btn btn--grey"
            @click="toStep(0)"
          >
            back
          </button>
          <div
            id="error-device-modal"
            class="error"
          >
            {{ errorMessage }}
          </div>
          <button
            id="continue-device-modal"
            class="btn"
            @click="toStep(2)"
          >
            continue
          </button>
        </div>
      </template>
      <template v-if="currentStep === 2">
        <div
          v-if="deviceType === deviceOptions.safe.type"
          class="modal__description"
        >
          Name your safe something descriptive! You can change this later
        </div>
        <div
          v-else
          class="modal__description"
        >
          Name the doors you have wired, ensuring the highlighted label matches the door you have
          wired.
        </div>
        <div class="flex-grid">
          <template class="device-image flex-grid">
            <safe-image
              v-if="deviceType === deviceOptions.safe.type"
              :mac-address="macAddress ? macAddress : 'a1:b2:c3:d4:e5:f6'"
              class="column--two"
            />
            <link-device-image
              v-else
              :door0="deviceColours.door0"
              :door1="deviceColours.door1"
              :door2="deviceColours.door2"
              :door3="deviceColours.door3"
              :mac-address="'#000000'"
              class="column--two"
            />
          </template>
          <div class="form-container column--two">
            <template v-for="(device, index) in newDevices">
              <div
                :key="index"
                class="device-name-container"
              >
                <div class="form-container">
                  <label
                    v-if="deviceType === deviceOptions.safe.type"
                    class="form-label"
                  >Name</label>
                  <label
                    v-else
                    class="form-label"
                  >Door {{ index }}</label>
                  <template v-if="index === 0">
                    <input
                      :id="index + '-door-name-device-modal'"
                      v-model="newDevices[index].name"
                      v-focus
                      class="form-field"
                      type="text"
                      @focus="changeColour(`door${index}`)"
                      @blur="removeColour(`door${index}`)"
                    />
                  </template>
                  <template v-else>
                    <input
                      :id="index + '-door-name-device-modal'"
                      v-model="newDevices[index].name"
                      class="form-field"
                      type="text"
                      @focus="changeColour(`door${index}`)"
                      @blur="removeColour(`door${index}`)"
                    />
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="modal_footer">
          <button
            id="back-device-modal"
            class="btn btn--grey"
            @click="toStep(1)"
          >
            back
          </button>
          <div
            id="error-device-modal"
            class="error"
          >
            {{ errorMessage }}
          </div>
          <button
            v-if="deviceType !== deviceOptions.safe.type"
            id="submit-device-modal"
            class="btn"
            @click="submit"
          >
            Add Device
          </button>
          <button
            v-if="deviceType === deviceOptions.safe.type"
            id="continue-device-modal"
            class="btn"
            @click="toStep(3)"
          >
            continue
          </button>
        </div>
      </template>
      <template v-if="currentStep === 3">
        <div class="modal__description">
          Select your device authentication settings.
        </div>
        <div class="flex-grid">
          <div class="column--two">
            <label class="form-label">Primary Authentication Method</label>
            <p class="sub-label m-0">
              Select one primary authentication method to enable for your users.
            </p>
            <select
              v-model="authType"
              class="form-field select-dropdown"
              data-testid="auth-method-dropdown"
            >
              <option
                v-for="type in authTypes"
                :key="type.value"
                :value="type"
              >
                {{ type.label }}
              </option>
            </select>
            <div
              class="pin-tooltip"
              data-testid="pin-tooltip-p"
            >
              {{ authType.message }}
            </div>
            <div
              v-if="authType.consentNeeded"
              class="biometric-tooltip"
              data-testid="biometric-tooltip-p"
            >
              <input
                id="biometric-consent-check"
                v-model="biometricConsentCheck"
                type="checkbox"
              />
              I have read and complied with the above. <span class="required">*</span>
            </div>
          </div>
          <div class="column--two">
            <label class="form-label">Secondary Authentication Method</label>
            <p class="sub-label m-0">
              Additional authentication methods, that can be used to enhance security
            </p>
            <div class="flex-grid-row">
              <toggle
                data-testid="two-credential-auth-toggle"
                class="mt-1"
                :toggle="twoCredentialAuthToggle"
                v-on:toggle-clicked="toggleTwoCredentialAuth"/>
              <label class="pl-1 mt-1 form-label">Two Credential Authentication</label>
            </div>
            <div class="flex-grid-row mt-1">
              <p class="sub-label mr-1">Rules</p>
              <select
                class="form-field select-dropdown"
                data-testid="2pa-auth-dropdown"
                v-model="twoPersonAuthMode"
                :disabled="!twoCredentialAuthToggle">
                <option
                  v-for="type in twoPersonAuthModes"
                  :key="type.value"
                  :value="type"
                >
                    {{ type.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal_footer">
          <button
            id="back-device-modal"
            class="btn btn--grey"
            @click="toStep(2)"
          >
            back
          </button>
          <div
            id="error-device-modal"
            class="error"
          >
            {{ errorMessage }}
          </div>
          <div v-tooltip="{content: emitSettingsDisabled() ? 'Consent checkbox required' : ''}">
            <button
              id="submit-device-modal"
              class="btn"
              :disabled="loading || emitSettingsDisabled()"
              @click="submit"
            >
              Add Device
            </button>
          </div>
        </div>
      </template>
    </div>
    <div class="modal-overlay" />
  </div>
  <!-- eslint-enable max-len -->
</template>

<script>
import REGEX from '@/global/utilities.js'
import constants from '@/global/constants.js'
import Loader from './loader'
import feather from 'feather-icons'
import door from '@/assets/physical_door.svg'
import cabinet from '@/assets/server_cabinet.svg'
import safe from '@/assets/safe.svg'
import linkDeviceImage from './linkDeviceImage.vue'
import toggle from './toggle.vue'
import safeImage from './safeImage.vue'

export default {
  name: 'AddDevice',
  components: {
    loader: Loader,
    linkDeviceImage,
    toggle,
    safeImage,
  },
  props: ['loading', 'scannedAddress'],
  data() {
    return {
      newDevices: [],
      errorMessage: '',
      deviceType: '',
      currentStep: 0,
      numberOfDevices: 0,
      twoCredentialAuthToggle: false,
      macAddress: this.scannedAddress ? this.scannedAddress : '',
      deviceOptions: {
        door: {
          type: 'door',
          quantity: 4,
        },
        cabinet: {
          type: 'cabinet',
          quantity: 2,
        },
        safe: {
          type: 'safe',
          quantity: 1,
        },
      },
      deviceColours: {
        door0: null,
        door1: null,
        door2: null,
        door3: null,
        macAddress: '#7FBF42',
      },
      doorIcon: door,
      cabinetIcon: cabinet,
      safeIcon: safe,
      closeIcon: feather.icons.x.toSvg(),
      subtractIcon: feather.icons['minus-circle'].toSvg(),
      addIcon: feather.icons['plus-circle'].toSvg(),
      authTypes: constants.authenticationModes,
      authType: constants.authenticationModes[0],
      twoPersonAuthModes: constants.twoPersonAuthModes,
      twoPersonAuthMode: constants.twoPersonAuthModes[0],
      biometricConsentCheck: false,
    }
  },
  methods: {
    submit() {
      this.errorMessage = ''
      if (this.doorNamesValidation()) {
        const _payload = this.generateDevicesPayload()
        this.$emit('add-device', _payload)
      }
    },
    // Deep copy new devices and assign Unnamed type to unfilled names
    generateDevicesPayload() {
      const _devices = this.deepCopy(this.newDevices)
      const _payload = _devices.map((device) => {
        if (this.isEmptyString(device.name)) {
          device.name = `Unnamed ${device.type}`
        }
        device.authenticationMode = this.authType.value
        /*
         * By default 2 Credential Auth is disabled by setting
         * the field twoPersonAuthTimeout = 0. When enabled
         * this field is set to a timeout of 60s to let the back
         * end know that 2 CA is active for this device
         */
        device.twoPersonAuthTimeout = this.twoCredentialAuthToggle ? constants.twoCredentialAuthTimeout : 0
        device.twoPersonAuthMode = this.twoCredentialAuthToggle ? this.twoPersonAuthMode.value : constants.twoPersonAuthModes[0].value
        return device
      })
      return _payload
    },
    isSelected(option) {
      return this.deviceType === option
    },
    changeColour(door) {
      const _green = '#7FBF42'
      this.deviceColours[door] = _green
    },
    removeColour(door) {
      this.deviceColours[door] = null
    },
    closeModal() {
      this.$emit('close')
    },
    selectDeviceType(option) {
      const {type, quantity} = option
      // Deselect if already selected
      if (this.isSelected(type)) {
        this.numberOfDevices = null
        this.deviceType = null
      } else {
        this.numberOfDevices = quantity
        this.deviceType = type
      }
    },
    toggleTwoCredentialAuth() {
      this.twoCredentialAuthToggle = !this.twoCredentialAuthToggle
    },
    /*
     * Attr will be set from /?device=parent_mac_address query
     * device or manually, user will specify type of solution they want
     * (door vs cabinet) specified number of devices will be created
     * sequentially based on first mac address
     */
    generateDevices() {
      this.newDevices = []
      const _addresses = this.generateAddressGroup(this.macAddress, this.numberOfDevices)
      /* eslint-disable no-loops/no-loops */
      for (let i = 0; i < this.numberOfDevices; i++) {
        this.newDevices.push({
          parentDevice: this.macAddress,
          serialNumber: _addresses[i],
          type: this.deviceType,
          name: '',
          isBypass: true,
          authenticationMode: 0,
          twoPersonAuthTimeout: 0,
        })
      }
      /* eslint-enable no-loops/no-loops */
    },
    toStep(stepNumber) {
      let _canProceed = false
      this.errorMessage = ''
      switch (stepNumber) {
      case 1:
        _canProceed = this.deviceSelectionValidation()
        break
      case 2:
        _canProceed = this.macAddressValidation()
        this.generateDevices()
        break
      case 3:
        _canProceed = this.doorNamesValidation()
        break
      default:
        _canProceed = true
        break
      }
      if (_canProceed) {
        this.currentStep = stepNumber
      }
    },
    macAddressValidation() {
      const _regex = REGEX.macAddress
      if (this.macAddress && _regex.test(this.macAddress)) {
        return true
      }
      this.errorMessage = 'Please enter a valid MAC address.'
      return false
    },
    // Help type mac addresses
    macHelper(event) {
      const BACKSPACE = 8
      const maxLength = 17
      const currentPosition = this.macAddress.length
      if (event.keyCode !== BACKSPACE && currentPosition % 3 === 2 && currentPosition < maxLength) {
        this.macAddress = this.macAddress.concat(':')
      }
    },
    deviceSelectionValidation() {
      if (this.deviceType && this.numberOfDevices) {
        return true
      }
      this.errorMessage = 'Please select a solution for your device.'
      return false
    },
    /*
     * Check if at least one name has been filled in.
     */
    doorNamesValidation() {
      const hasDeviceWithName = this.newDevices.some((device) => {
        return !this.isEmptyString(device.name)
      })
      if (!hasDeviceWithName) {
        this.errorMessage = 'Please enter at least one name.'
        return false
      }

      const validNames = this.newDevices.every((device) => {
        return this.isEmptyString(device.name) || REGEX.deviceName.test(device.name)
      })
      if (!validNames) {
        this.errorMessage = 'Invalid name, try removing apostrophes or slashes'
        return false
      }
      return true
    },
    emitSettingsDisabled() {
      return this.authType.consentNeeded && !this.biometricConsentCheck
    },
  },
}
</script>

<style lang="scss" scoped>
.required {
  color: $red;
  vertical-align: super;
  font-size: smaller; /* Optional: to make the asterisk smaller */
}
.device {
  &__heading {
    font-size: $default-font;
    margin-bottom: 1em;
  }
  &-container {
    @include flex-display();
    @include flex-justify-content(space-around);
    margin: 2em 0;
    width: 100%;
    @media #{$mobile} {
      @include flex-direction(column);
      @include flex-justify-content(center);
      @include flex-align-items(center);
    }
  }
  &__solution {
    &-ports {
      font-size: $small-font;
      color: $grey-text;
    }
  }
  &-image {
    @include flex-display();
    @include flex-justify-content(space-between);
    @include flex-align-items(center);
  }
  &-name {
    &-container {
      @include flex-display();
      @include flex-align-items(center);
      width: 100%;
    }
    &__remove {
      margin-left: 1em;
      color: $blue;
      transition: transform 0.3s ease-in-out;
      &:hover {
        cursor: pointer;
        transform: scale(1.2);
      }
    }
    &__add {
      @include flex-display();
      @include flex-align-items(center);
      color: $grey-text;
      font-weight: 600;
      font-size: $small-font;
      width: fit-content;
      &:hover {
        cursor: pointer;
        .device-name__add-icon {
          transform: scale(1.2);
        }
      }
      &-icon {
        color: $blue;
        margin-right: 0.5em;
        transition: transform 0.3s ease-in-out;
      }
    }
  }
}
.btn__image:hover {
  .device__solution-ports {
    color: $white;
  }
}
.modal_footer {
  align-items: flex-end;
}
</style>
